<section class="hero">
  <div>
    <p class="eyebrow">Operations</p>
    <h1>Review pipeline</h1>
  </div>

  <div class="interval-toggle">
    <button type="button"
      [class.active]="interval() === 'week'"
      (click)="changeInterval('week')">Weekly</button>
    <button type="button"
      [class.active]="interval() === 'day'"
      (click)="changeInterval('day')">Daily</button>
  </div>
</section>

@if (data(); as ops) {
  <section class="metric-grid">
    <app-metric-card label="Total Runs" [value]="ops.summary.totalReviewRuns" hint="Review executions" />
    <app-metric-card label="Completed" [value]="ops.summary.completedReviewRuns" hint="Successfully finished" tone="good" />
    <app-metric-card label="Failed" [value]="ops.summary.failedReviewRuns" hint="Errored runs" tone="danger" />
    <app-metric-card label="Avg Duration" [value]="formatDurationMs(ops.summary.avgReviewDurationMs)" hint="Per run" />
    <app-metric-card label="Avg Issues / Run" [value]="(ops.summary.avgIssuesPerRun | number:'1.1-2') ?? '0'" hint="Backend computed" />
    @if (ops.summary.aiApiErrorCount > 0) {
      <app-metric-card label="AI API Errors" [value]="ops.summary.aiApiErrorCount" hint="Inferable from failures" tone="warn" />
    }
    @if (ops.summary.totalAiTokensUsed !== null) {
      <app-metric-card label="Tokens Used" [value]="(ops.summary.totalAiTokensUsed | number:'1.0-0') ?? '0'" hint="Total AI tokens" />
    }
    @if (ops.summary.totalAiCostEstimate !== null) {
      <app-metric-card label="Cost Estimate" [value]="'$' + ((ops.summary.totalAiCostEstimate | number:'1.2-4') ?? '0')" hint="Estimated AI cost" />
    }
  </section>

  @if (ops.trends.points.length > 0) {
    <section class="chart-grid">
      <article class="panel chart-panel">
        <div class="panel-head">
          <div>
            <p class="panel-kicker">Run Volume</p>
            <h2>Review runs and failures</h2>
          </div>
        </div>
        <div class="chart-shell">
          <canvas baseChart [data]="runVolumeChartData()" [type]="'bar'" [options]="barChartOptions"></canvas>
        </div>
      </article>

      <article class="panel chart-panel">
        <div class="panel-head">
          <div>
            <p class="panel-kicker">Performance</p>
            <h2>Average review duration (seconds)</h2>
          </div>
        </div>
        <div class="chart-shell">
          <canvas baseChart [data]="avgDurationChartData()" [type]="'line'" [options]="lineChartOptions"></canvas>
        </div>
      </article>
    </section>
  }

  @if (ops.issueCountByRun.length) {
    <section class="panel">
      <div class="panel-head">
        <div>
          <p class="panel-kicker">Issue Load</p>
          <h2>Issues per review run</h2>
        </div>
      </div>
      <div class="table-shell">
        <table>
          <thead>
            <tr>
              <th>Pull Request</th>
              <th>Repository</th>
              <th>Issues</th>
              <th>Completed</th>
            </tr>
          </thead>
          <tbody>
            @for (run of ops.issueCountByRun; track run.reviewRunId) {
              <tr>
                <td>PR #{{ run.azurePullRequestId }}</td>
                <td>{{ run.repositoryName }}</td>
                <td>{{ run.totalIssues }}</td>
                <td>{{ run.completedAt | localDate:'short' }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </section>
  }
} @else if (loading()) {
  <section class="state-card">Loading operations data…</section>
} @else if (error()) {
  <section class="state-card error">
    <p>{{ error() }}</p>
    <button type="button" class="state-button" (click)="load()">Try again</button>
  </section>
} @else {
  <section class="state-card">
    <p>No operations data returned for the selected range.</p>
  </section>
}
